<template>
	<v-card class="elevation-0 events-page page">
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<div v-else-if="isBlocked !== null">
			<div class="categories-page__wrap">
				<div>
					<div class="d-flex align-center event__search px-4 mb-7">
						<div class="d-flex w-100 mr-6 align-center" style="width: 100%">
							<input
								type="text"
								class="post-preview-card__comment"
								placeholder="Search"
								v-model="filters.search"
								@input="filterSearch"
							/>
						</div>
						<img :src="searchIcon" alt="" />
					</div>
				</div>
	
				<div class="d-flex">
					<v-skeleton-loader width="600" v-bind="attrs" type="card" v-if="false">
					</v-skeleton-loader>
					<FeaturedPost v-else />
				</div>
			</div>
	
			<div
				class="post__fake-btn-modal-container mt-5"
				@click="openCreatePostModal"
				v-if="!this.isLoading"
			>
				<div>
					<Avatar
						class="mr-4 post-preview-card__avatar"
						size="30"
						:avatar="profile.user_logo"
					/>
					What’s on your mind?
				</div>
	
				<div>
					<img :src="penIcon" alt="penIcon" loading="lazy" />
				</div>
			</div>
	
			<div>
				<div>
					<v-btn
						class='post__btn-filters'
						:class="{ 'post__btn-filters-active': isButtonActive('clear') }"
						@click='clearButtonHandler'
					>
						All
					</v-btn>
	
					<v-btn
						class='post__btn-filters'
						:class="{ 'post__btn-filters-active': isButtonActive('categories') }"
						@click='categoriesButtonHandler'
					>
						My Categories
					</v-btn>
	
					<v-btn
						class='post__btn-filters'
						:class="{ 'post__btn-filters-active': isButtonActive('chapters') }"
						@click='chaptersButtonHandler'
					>
						My Groups
					</v-btn>
				</div>
			</div>
	
			<PostFilterModal
				v-on:closeModal='closeModal'
				:show='showModal'
				:selected-button='selectedButton'
				:current-active-button='this.currentActiveButton'
				:currentActiveButtonTitle="currentActiveButtonTitle"
				@applySelection='applySelection'
				@setItems='setItems'
			/>
	
			<div class="d-flex mt-3">
				<v-skeleton-loader
					v-if="isLoading"
					v-bind="attrs"
					width="600"
					type="list-item, list-item-three-line, card-heading"
				></v-skeleton-loader>
	
				<div v-else style="width: 100%">
	
					<div v-if="this.forumCategories.length === 0" class="mt-5 page-container">
						<NewsFeedEmpty
							title="Your forum categories is empty at the moment."
							description="Check back later."
						/>
					</div>
	
					<div v-for="(category, index) in forumCategories" :key="index">
						<CategoryCard :category="category" />
					</div>
				</div>
			</div>
	
			<div
				class="d-flex my-9 justify-center home-page__pagination"
				v-if="!isLoading && forumCategories.length > 0"
			>
				<Pagination 
					:page="filters.page"
					:pageCount="+this.pageForumCategories"
					v-on:pageChange="onPageChange"
				/>
			</div>
	
			<div v-if="isShowCreatePostModal">
				<CreatePostModal
					v-on:closeModal="closeCreatePostModal"
					:show="isShowCreatePostModal"
				/>
			</div>
	
			<v-btn
				v-show="isShowCreatePostButton"
				@click="openCreatePostModal"
				bottom
				right
				class="add-post-button"
				fixed
				fab
			>
				<v-icon>mdi-plus</v-icon>
			</v-btn>
	
			<v-btn
				v-show="isVisible"
				@click="scrollToTop"
				bottom
				right
				fixed
				fab
			>
				<v-icon>mdi-chevron-up</v-icon>
			</v-btn>
		</div>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import FeaturedPost from '@/components/Post/PostFeaturedPreview'
import searchIcon from '@/assets/images/search.svg'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty'
import CategoryCard from '@/components/Forum/CategoryCard'
import CreatePostModal from '@/components/Modals/CreateForumPostModal.vue'
import Avatar from '@/components/Avatar.vue'
import penIcon from '@/assets/images/icon-pen.svg'
import PostFilterModal from '@/components/Modals/PostFilterModal.vue'
import Pagination from '@/components/Pagination.vue'
import PageBlocked from '@/components/PageBlocked'
import Block from '@/mixins/Block.js'
import _ from 'lodash'

const DEBOUNCE_TIMEOUT = 500

export default {
	name: 'ForumCategoriesPage',
	mixins: [Block],
	components: {
		PostFilterModal,
		Avatar,
		CreatePostModal,
		FeaturedPost,
		NewsFeedEmpty,
		CategoryCard,
		Pagination,
		PageBlocked
	},

	methods: {
		...mapActions('forum', ['fetchForumCategories']),
		toggleVisibility() {
			this.isVisible = window.scrollY > 1000; // Show the button when scrolling down a certain amount
		},
		scrollToTop() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
		},
		closeModal() {
			this.showModal = false
		},
		setItems(item) {
			if (item.listItem.hasOwnProperty('chapter_id')) {
				this.setChapters(item.listItem)
			}
		},
		setChapters(chapter) {
			if (this.selectedChapters.includes(chapter.chapter_id)) {
				this.selectedChapters = this.selectedChapters.filter(
					(item) => item !== chapter.chapter_id,
				)
			} else {
				this.selectedChapters = [...this.selectedChapters, chapter.chapter_id]
			}
		},
		applySelection() {
			this.filters.groups = this.selectedChapters
			this.showModal = false
		},
		isButtonActive(name) {
			return this.selectedButton.includes(name)
		},
		checkScreenWidth() {
			this.isShowCreatePostButton = window.innerWidth >= 1264;
		},
		openCreatePostModal() {
			this.isShowCreatePostModal = true
		},
		closeCreatePostModal() {
			this.isShowCreatePostModal = false
		},

		onPageChange(page) {
			if (this.filters.page !== page) {
				const params = {
					filter: this.filters.filter,
					chapter_id: this.filters.groups,
	
					search: this.filters.search,
					page: page,
				}
				this.filters.page = page
				const queryString = this.formatFilters(params)
				this.getCategories(queryString)
			
			}
		},

		formatFilters(filters) {
			const { search, page, filter, chapter_id } = filters

			const groupIds = chapter_id.reduce((prev, next) => {
				return `${prev}&chapter_id[]=${next}`
			}, '')

			let queryString = `&filter=${filter}${groupIds}&page=${page}&expand=lastActiveForum`

			if (search !== undefined && search.length > 0) {
				queryString += `&search=${search}`
			}

			return queryString
		},

		async getCategories(additionalQueryParams = '') {
			await this.fetchForumCategories(additionalQueryParams)
		},

		filterSearch(e) {
			clearTimeout(this.timer)

			const params = {
				filter: this.filters.filter,
				chapter_id: this.filters.groups,

				search: e.target.value,
				page: 1,
			}

			this.filters.page = 1
			const queryString = this.formatFilters(params)

			this.timer = setTimeout(() => {
				this.getCategories(queryString)
			}, DEBOUNCE_TIMEOUT)
		},
		clearButtonHandler() {
			this.currentActiveButton = 'clear'
			this.currentActiveButtonTitle = ''
			this.selectedButton = ['clear']
			this.selectedChapters = []

			this.filters = {
				filter: null,
				groups: [],
				search: this.filters.search,
			}
			this.showModal = false
		},
		filterSpecifiedValues(list, filterValues) {
			return list.filter(item => !filterValues.includes(item))
		},

		getFilteredChips(
			selectedButtons,
			handleButtonName,
			mutuallyExclusiveButtons
		) {
			const isButtonPresentInlist = this.selectedButton.includes(handleButtonName)

			if (!isButtonPresentInlist) {
				return this.filterSpecifiedValues([...this.selectedButton, handleButtonName], mutuallyExclusiveButtons)
			} else {
				const filteredValues = this.filterSpecifiedValues(this.selectedButton, handleButtonName, [handleButtonName])

				if ( filteredValues.length <= 0 ) {
					return ['clear'];
				}

				return filteredValues;
			}
		},
		chaptersButtonHandler() {
			this.currentActiveButton = 'chapters'
			this.currentActiveButtonTitle = 'My groups'
			const mutuallyExclusiveButtons = ['clear']

			this.selectedButton = this.getFilteredChips(
				this.selectedButton,
				this.currentActiveButton,
				mutuallyExclusiveButtons
			)

			const isHandleButtonActive = this.selectedButton.includes(this.currentActiveButton)

			if (!isHandleButtonActive) {
				this.selectedChapters = []
				this.filters = {
					...this.filters,
					groups: [],
				}
			}

			this.showModal = isHandleButtonActive
		},
		categoriesButtonHandler() {
			this.currentActiveButton = 'categories'
			this.currentActiveButtonTitle = 'My Categories'
			const mutuallyExclusiveButtons = ['clear']

			this.selectedButton = this.getFilteredChips(
				this.selectedButton,
				this.currentActiveButton,
				mutuallyExclusiveButtons
			)

			const isHandleButtonActive = this.selectedButton.includes(this.currentActiveButton)

			this.filters = {
				...this.filters,
				filter: isHandleButtonActive ? 'follow' : null,
			}
		},
	},

	created() {
		if (!this.isBlocked || this.isBlocked === null) {
			this.fetchForumCategories('expand=lastActiveForum')
		}
	},
	mounted() {
		window.addEventListener('scroll', this.toggleVisibility)
		window.addEventListener('resize', this.checkScreenWidth);
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.toggleVisibility)
		window.addEventListener('resize', this.checkScreenWidth);
	},

	computed: {
		...mapGetters('auth', ['isAuthenticated', 'profile']),
		...mapGetters('forum', ['forumCategories', 'isLoading', 'pageForumCategories']),
	},

	watch: {
		'filters.filter': function(val) {
			const params = {
				filter: val,

				chapter_id: this.filters.groups,
				search: this.filters.search,
				page: 1,
			}
			this.filters.page = 1
			const queryString = this.formatFilters(params)
			this.getCategories(queryString)
		},
		'filters.groups': function(next, prev) {
			const isValuesEmptyOrEqual = (next.length <= 0 && prev.length <= 0) ||
				(_.isEqual(next, prev))

			if (isValuesEmptyOrEqual) {
				return false
			}


			const params = {
				filter: this.filters.filter,

				chapter_id: next,
				search: this.filters.search,
				page: 1,
			}
			this.filters.page = 1
			const queryString = this.formatFilters(params)
			this.getCategories(queryString)
		},
	},

	data() {
		return {
			attrs: {
				class: 'mb-6 mt-6',
				elevation: 0,
			},
			penIcon,
			selectedButton: ['clear'],

			isVisible: false,
			isShowCreatePostButton: true,
			isShowCreatePostModal: false,

			currentActiveButton: '',
			currentActiveButtonTitle: '',
			showModal: false,
			selectedChapters: [],

			timer: 0,
			filters: {
				groups: [],
				filter: null,

				page: 1,
				search: '',
			},
			searchIcon,

			search: '',
			page: '',
			pageBlockedName: 'forums'
		}
	},
}
</script>

<style lang="scss">
.categories-page {
	background: #f1f1f1 !important;
	max-width: 600px;
	width: 100%;

	&__divider {
		border-color: #000 !important;
		mix-blend-mode: normal;
		opacity: 0.1;
	}

	&__time {
		color: rgb(74, 74, 74);
		font-size: 24px;
		font-family: Montserrat;
		font-weight: bold;
	}

	.event {
		&__search {
			background: white;
			height: 54px;
			border-radius: 10px;
			border: 1px solid rgb(230, 230, 230);
			max-width: 600px;
		}
		&__filters {
			color: white;
			font-size: 14px;
			font-family: Montserrat;
			font-weight: bold;
			letter-spacing: 0.36px;
			margin-top: 20px;
			background: rgb(65, 161, 216) !important;
			border-radius: 15px;
			box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.1);
			text-transform: capitalize !important;
			align-items: center;
		}
		@media screen and (max-width: 1264px) {
			&__search {
				max-width: none;
			}
		}
	}

	.post {
		&__search {
			background: white;
			height: 54px;
			border-radius: 10px;
			border: 1px solid rgb(230, 230, 230);
			max-width: 600px;
		}
		&__btn-filters {
			color: white;
			font-size: 14px;
			font-family: Montserrat;
			font-weight: bold;
			letter-spacing: 0.36px;
			margin-top: 20px;
			background: rgb(65, 161, 216) !important;
			border-radius: 15px;
			box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.1);
			text-transform: capitalize !important;
			align-items: center;
			margin-right: 15px;
			&-active {
				background-color: #02668a !important;
				color: white !important;
			}
		}
		@media screen and (max-width: 1264px) {
			&__search {
				max-width: none;
				width: 100%;
			}
		}
	}
}

.post {
	&__search {
		background: white;
		height: 54px;
		border-radius: 10px;
		border: 1px solid rgb(230, 230, 230);
		max-width: 600px;
	}
	&__btn-filters {
		color: white;
		font-size: 14px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
		letter-spacing: 0.36px;
		margin-top: 20px;
		background: rgb(65, 161, 216) !important;
		border-radius: 15px;
		box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.1);
		text-transform: capitalize !important;
		align-items: center;
		margin-right: 15px;
		&-active {
			background-color: #02668a !important;
			color: white !important;
		}
	}

	&__fake-btn-modal {
		&-container {
			display: flex;
			align-items: center;
			justify-content: space-between;
			height: 54px;
			background: rgb(255, 255, 255);
			border: 1px solid rgb(230, 230, 230);
			border-radius: 10px;
			padding: 20px 15px;
			max-width: 600px;
			cursor: pointer;

			color: rgb(160, 160, 160);
			font-size: 15px;
			font-family: Montserrat, sans-serif;
			font-weight: normal;
			letter-spacing: -0.43px;
		}
	}

	@media screen and (max-width: 1264px) {
		&__search {
			max-width: none;
			width: 100%;
		}
		&__fake-btn-modal-container {
			max-width: none;
			width: 100%;
		}
	}
}
@media screen and (max-width: 1264px) {
	.page-container {
		max-width: 600px;
	}
}
</style>
